<template>
    <b-card-text>
        <div v-if="!loaded">
            <img src="assets/ajax-loader.gif" style="padding: 10px;" />
        </div>
        <div v-if="loaded">
            <div v-if="resources.list.length > 0">
                <b-row class="p-2">
                    <b-col sm="3">
                        <strong>Report:</strong>
                    </b-col>
                    <b-col>
                        <strong>Description:</strong>
                    </b-col>
                </b-row>
                <b-row
                    :key="item.id"
                    v-for="item in resources.list"
                    class="border-bottom p-2"
                >
                    <b-col sm="3" class="text-capitalize">
                        <a
                            v-if="item.id === 52"
                            @click.stop.prevent="generateReport(item)"
                            href
                            >{{ item.name }}</a
                        >
                        <b-link
                            v-else-if="VIEW_REPORT.includes(item.id)"
                            :to="'/report/' + item.id"
                            >{{ item.name }}</b-link
                        >
                        <b-link
                            v-else-if="(module == 10)"
                            :to="'/report/custom/' + item.id"
                            >{{ item.name }}</b-link
                        >
                        <a v-else :href="getReportURL(item)">{{ item.name }}</a>
                    </b-col>
                    <b-col> <div v-html="item.description"></div></b-col>
                </b-row>
            </div>
            <div v-else>
                <i>{{ noDataLabel }}</i>
                <a
                    v-if="isCustomReport"
                    :href="`mailto:vet-support@daysmart.com`"
                >
                    vet-support@daysmart.com.
                </a>
            </div>
        </div>
    </b-card-text>
</template>
<script>
import ReportHelper from "./helper";
import REPORT from "@/constants/report";

export default {
    components: {},
    mixins: [ReportHelper],
    props: {
        module: {
            default() {},
            type: Number
        }
    },
    data() {
        return {
            loaded: false,
            resources: {
                list: []
            },
            noDataLabel: "No records available",
            isCustomReport: false
        };
    },
    computed: {},
    created() {},
    mounted() {
        return this._getSetting().then(() => {
            if (this.module == 10) {
                this.initCustomReport();
            } else {
                this.initStandardReport();
            }
        });
    },
    methods: {
        initStandardReport() {
            let self = this;
            self.loaded = false;

            return this.$http
                .get(process.env.BARRACUDA + "report/reports", {
                    params: {
                        module: this.module
                    }
                })
                .then(function (response) {
                    self.resources.list = response.data.response.resources.filter(
                        item => {
                            if (self._hasAccess(item.permission_key)) {
                                return true;
                            }
                        }
                    );

                    self.loaded = true;
                });
        },
        initCustomReport() {
            let self = this;
            self.loaded = false;
            self.isCustomReport = true;

            return this.$http
                .get(process.env.BARRACUDA + "report/custom-reports")
                .then(function (response) {
                    self.resources.list = response.data.response.resources.filter(
                        item => {
                            if (item.isactive && item.ispublish) {
                                return true;
                            }
                        }
                    );

                    if (self.resources.list.length == 0) {
                        self.noDataLabel =
                            "If there are reports of interest that are not standard in our Reports module, Administrators may contact the support team and have a custom report designed for a professional service fee. Once designed, the report will appear under this tab. For more information, please contact";
                    }

                    self.loaded = true;
                });
        },
        getReportURL(data) {
            if (this.VIEW_REPORT.includes(data.id)) {
                return "/view/report/" + data.id;
            } else {
                return process.env.CI_APPS + "report/report/view/" + data.id;
            }
        },
        async generateReport(data) {
            const response = await $.post(
                process.env.APPS + "report/report/generateReport",
                { fm_generate_report_id: data.id, regenerate: null }
            );

            if (typeof response.newAnnualURL === "undefined") {
                if (response.mode == 0) {
                    this._message(response.message, "info");
                }
            } else {
                this._redirect(response.newAnnualURL);
            }
        }
    }
};
</script>
